import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSingleSignon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 23,
	viewBox: "0 0 21 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.7891 13.7892C17.3208 13.7892 20.1837 10.9262 20.1837 7.3946C20.1837 3.86296 17.3208 1 13.7891 1C10.2575 1 7.39453 3.86296 7.39453 7.3946C7.39453 10.9262 10.2575 13.7892 13.7891 13.7892Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.3288 19.1181L4.19727 16.9866",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.13153 22.3154L1 20.1838",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 20.1837L9.27035 11.9133",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconSingleSignon;
